import { useLocation } from 'react-router-dom';
import DocsAuthenticationRedirect from './DocsAuthenticationRedirect';
import { useClientLogin } from '../../providers/ClientLogin.provider';
import LoginContainer from '../LoginPages/LoginContainer';
import Login from '../LoginPages/Login';

const DocsAuthenticationContainer: React.FC = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const redirect = params.get('redirect');

  const { isAuthenticated } = useClientLogin();

  return (
    <div>
      {isAuthenticated !== null && (
        <div>
          {isAuthenticated && <DocsAuthenticationRedirect slug={redirect || ''} />}
          {!isAuthenticated && (
            <LoginContainer>
              <Login />
            </LoginContainer>
          )}
        </div>
      )}
    </div>
  );
};

export default DocsAuthenticationContainer;
